module.exports = __webpack_public_path__ + "img/D202010_3.f52106a2.jpg";